import { useEffect } from "react";

/**
 * Injects BreadcrumbList JSON-LD while mounted.
 * @param {{ name: string, url: string }[]} items
 */
export function useBreadcrumbJsonLd(items, scriptAttrValue) {
  useEffect(() => {
    const list = Array.isArray(items) ? items : [];
    if (!list.length) return;

    const payload = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: list.map((item, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: item.name,
        item: item.url,
      })),
    };

    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-selena-page", scriptAttrValue);
    el.textContent = JSON.stringify(payload);
    document.head.appendChild(el);

    return () => {
      document.querySelectorAll(`script[data-selena-page="${scriptAttrValue}"]`).forEach((n) => n.remove());
    };
  }, [items, scriptAttrValue]);
}
